@charset "UTF-8";

/* src/app/views/contract-dealer/contract-search-dealer.component.scss */
.title {
  font-weight: normal;
  font-style: normal;
  font-size: 36px;
  line-height: 50px;
  color: #000000;
  padding: 2%;
}
.filtro {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  margin-bottom: 6px;
  display: inline-block;
}
.image {
  margin-top: 5%;
  margin-bottom: 5%;
}
.chassi-label {
  font-weight: normal;
  font-size: x-large;
  margin-top: 5%;
}
.margin-top-5 {
  margin-top: 5%;
}
.chassi-margin-top {
  margin-top: 30px;
}
.container {
  padding: 20px;
  box-sizing: border-box;
}
.container > .grid {
  margin: 0 !important;
}
.container > .grid > [class*=col-] {
  padding-left: 20px;
  padding-right: 20px;
}
.btn-next {
  width: 10%;
  height: 116% !important;
  margin: 0 auto;
  font-family:
    Ford Antenna Light,
    "Trebuchet MS",
    Arial,
    Helvetica,
    sans-serif;
  font-size: 16px;
}
body .ui-widget {
  font-family:
    Ford Antenna Light,
    "Trebuchet MS",
    Arial,
    Helvetica,
    sans-serif;
  font-size: 12px;
  text-decoration: none;
}
.btn-pattern {
  width: 130px;
  height: 48px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 0 14px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 400;
}
.search-filters-wrapper {
  padding: 0 20px !important;
  margin-top: 20px !important;
  width: 100%;
  box-sizing: border-box;
}
::ng-deep .search-filters-wrapper .p-accordion,
::ng-deep .search-filters-wrapper .ui-accordion {
  width: 100%;
}
::ng-deep .search-filters-wrapper .p-accordion .p-accordion-content {
  padding: 20px !important;
}
::ng-deep .search-filters-wrapper .ui-accordion .ui-accordion-content {
  padding: 20px !important;
}
::ng-deep .search-filters-wrapper .p-accordion-content,
::ng-deep .search-filters-wrapper .ui-accordion-content {
  padding: 20px !important;
}
.filter-actions-row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  width: calc(100% - 48px);
  margin: 16px 24px 0;
  padding-top: 14px;
  border-top: 1px solid #d9d9d9;
  box-sizing: border-box;
}
.filters-grid {
  display: grid !important;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 12px;
  row-gap: 10px;
  align-items: start;
  width: calc(100% - 48px);
  margin: 8px 24px 0;
}
.filters-grid > [class*=col-],
.filters-grid > .filter-item {
  width: 100% !important;
  max-width: 100% !important;
  padding: 0;
  margin: 0;
  min-width: 0;
}
@media (max-width: 768px) {
  .filters-grid,
  .filter-actions-row {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    margin-top: 8px;
  }
  .filters-grid {
    column-gap: 10px;
  }
  .filter-actions-row {
    margin-top: 14px;
  }
}
.filters-grid input[pInputText] {
  height: 48px;
  border-radius: 10px;
  padding-left: 12px;
}
::ng-deep .filters-grid .ui-calendar .ui-inputtext,
::ng-deep .filters-grid .p-calendar .p-inputtext,
::ng-deep .filters-grid .p-datepicker .p-inputtext {
  height: 48px;
  border-radius: 10px;
}
::ng-deep .filters-grid .ui-dropdown,
::ng-deep .filters-grid .p-dropdown,
::ng-deep .filters-grid .ui-multiselect,
::ng-deep .filters-grid .p-multiselect {
  min-height: 48px;
  border-radius: 10px;
  width: 100%;
  display: inline-flex;
  align-items: center;
}
.filter-actions-row .btn-pattern {
  margin: 0 !important;
  box-shadow: none !important;
}
.filter-actions-row .btn-clear-filters {
  background: #ffffff !important;
  border: 2px solid #006fe8 !important;
  color: #006fe8 !important;
}
.filter-actions-row .btn-clear-filters:hover {
  background: #edf5ff !important;
  border-color: #006fe8 !important;
  color: #006fe8 !important;
}
.filter-actions-row .btn-search-filters {
  background: #006fe8 !important;
  border: 2px solid #006fe8 !important;
  color: #ffffff !important;
}
.filter-actions-row .btn-search-filters:hover {
  background: #2861a4 !important;
  border-color: #2861a4 !important;
  color: #ffffff !important;
}
.filter-actions-row .btn-pattern:disabled {
  opacity: 0.8;
}
.item-position {
  display: flex;
  justify-content: center;
  align-items: center;
}
.export-actions-row {
  margin-top: 20px;
  margin-bottom: 18px;
  padding-right: 20px;
}
::ng-deep .contract-results-table .p-datatable-wrapper {
  overflow-x: auto;
}
::ng-deep .contract-results-table table {
  min-width: 2140px;
  table-layout: auto;
}
::ng-deep .contract-results-table .col-plan-name {
  width: 410px !important;
  min-width: 410px !important;
}
::ng-deep .contract-results-table .col-limits {
  width: 340px !important;
  min-width: 340px !important;
}
::ng-deep .contract-results-table .p-datatable-thead > tr > th {
  white-space: nowrap;
}
::ng-deep .contract-results-table .p-datatable-tbody > tr > td {
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
}
::ng-deep .contract-results-table .cell-no-wrap {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
::ng-deep .custom-class-btn {
  font-size: 10pt !important;
}
.btn-action-menu {
  background-color: #046cea !important;
  color: #ffffff !important;
  border: 1px solid #046cea !important;
  border-radius: 50% !important;
  width: 40px;
  height: 40px;
  min-width: 40px !important;
  padding: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}
.btn-action-menu:hover {
  background-color: #0353a8 !important;
  border-color: #0353a8 !important;
}
::ng-deep .btn-action-menu .mat-mdc-button-persistent-ripple::before {
  display: none !important;
}
::ng-deep .btn-action-menu .mat-mdc-focus-indicator::before {
  display: none !important;
}
.btn-action-menu mat-icon {
  color: #ffffff !important;
  font-size: 18px;
  line-height: 1;
  width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.action-buttons-i {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #102b4e;
  color: white;
  border-radius: 50%;
  font-size: 16px;
  width: 40px;
  height: 40px;
  text-align: center;
  border: none;
}
.action-buttons-i:hover {
  background-color: #2e65a6;
}
::ng-deep .mat-mdc-menu-item .mdc-list-item__primary-text {
  color: #102b4e !important;
}
::ng-deep .mat-mdc-menu-item:hover {
  background-color: #d8dde3 !important;
}
::ng-deep .mat-mdc-menu-item:hover .mdc-list-item__primary-text {
  color: #4f5862 !important;
}
::ng-deep .mat-mdc-menu-item:hover .mat-icon {
  color: #4f5862 !important;
}
::ng-deep .cdk-overlay-container {
  z-index: 1200 !important;
}
.modal-body {
  display: block;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
}
.modal-itens {
  display: block;
  flex-direction: row;
  justify-content: flex-start;
  align-items: initial;
  margin-bottom: 10px;
}
.modal-itens-title {
  color: #333333;
  font-family: Ford F-1;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
}
.space {
  margin-left: 10px;
}
.space-first {
  margin-left: 20px;
}
.space-btn {
  margin-left: 40px;
}
.modal-radio {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 10px;
}
.modal-radio-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.radio-position {
  margin-left: 30px;
}
.radio-position-label {
  margin-left: 5px;
}
.modal-footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  margin-top: 20px;
}
::ng-deep .ui-dialog-titlebar-close .pi-times {
  display: none !important;
}
.btn-pdf {
  width: 150px;
  height: 35px;
}
.action-button-return {
  background-color: #ffffff;
  width: 100px;
  height: 35px;
  border: 1px solid #102b4e;
  border-radius: 20px;
  margin-bottom: 10px;
}
button.action-button-return .action-button-return-label {
  font-size: 12pt;
  font-weight: 500;
  color: #102b4e;
}
button.action-button-return:hover .action-button-return-label {
  color: #ffffff;
}
.action-button-return:hover {
  background: #2861a4;
  border: 1px solid #2861a4;
}
.action-button {
  float: right;
  background: #102b4e;
  border: 1px solid #102b4e;
  border-radius: 20px;
  margin-bottom: 10px;
}
.action-button-label {
  font-size: 12pt;
  font-weight: 500;
  color: #ffffff;
}
.action-button:hover {
  background: #2861a4;
  border: 1px solid #2861a4;
}
.action-button:disabled .action-button-label {
  color: #102b4e;
}
.action-button:disabled {
  background: #E5E5E5;
  border: 1px solid #102b4e;
}
.excel-export-button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: #046cea;
  border: 1px solid #046cea;
  border-radius: 8px;
  width: auto;
  height: 48px;
  cursor: pointer;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}
.excel-export-button-label {
  font-size: 15pt;
  font-weight: 500;
  color: #ffffff;
  white-space: nowrap;
}
.excel-export-button i {
  font-size: 18px;
  color: #ffffff;
}
.excel-export-button:hover:not(:disabled) {
  background: #0353a8;
  border-color: #0353a8;
}
.excel-export-button:disabled {
  background: #E5E5E5;
  border-color: #cccccc;
  cursor: not-allowed;
  opacity: 0.6;
}
.excel-export-button:disabled .excel-export-button-label,
.excel-export-button:disabled i {
  color: #999999;
}
::ng-deep .cdk-overlay-container {
  z-index: 1200 !important;
}
.modal-body {
  display: block;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
}
.modal-itens {
  display: block;
  flex-direction: row;
  justify-content: flex-start;
  align-items: initial;
  margin-top: 10px;
}
.modal-itens-title {
  color: #333333;
  font-family: Ford F-1;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  margin-bottom: 10px;
}
.modal-element {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: initial;
  color: #333333;
  font-family: Ford F-1;
  font-size: 14px;
  line-height: 24px;
  text-align: left;
}
.modal-element-title {
  margin-bottom: 5px;
  font-weight: 400;
}
.modal-element-label {
  margin-top: 15px;
  margin-bottom: 5px;
  font-weight: 400;
}
.modal-element-p {
  margin-bottom: 5px;
  font-weight: lighter;
}
.modal-element-input {
  margin-bottom: 10px;
  height: 38px;
}
.select-top {
  margin-top: -26px;
}
.space {
  margin-left: 10px;
}
.space-first {
  margin-left: 20px;
}
.space-second {
  margin-left: 81px;
}
.space-btn {
  margin-left: 40px;
}
.modal-inform {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
}
.modal-inform-two {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 3px;
}
.modal-bank-info {
  margin-top: -7px;
  display: block;
  flex-wrap: row;
  justify-content: flex-start;
  align-items: center;
}
::ng-deep .ui-dialog-titlebar-close .pi-times {
  display: none !important;
}
.modal-footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.btn-cancel {
  width: 220px;
  height: 35px;
}
.modal-radio {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 10px;
}
.modal-radio-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.radio-position {
  margin-left: 30px;
}
.radio-position-label {
  margin-left: 5px;
}
.btn-pdf {
  width: 150px;
  height: 35px;
}
.loading {
  position: absolute;
  top: 35%;
  left: 50%;
  font-size: 60px;
  font-weight: bold;
}
@media only screen and (max-width: 1024px) {
  .title {
    font-size: 28px;
    line-height: 38px;
    padding: 4%;
  }
  .chassi-label {
    font-size: large;
  }
  .btn-next,
  .btn-pattern,
  .btn-pdf,
  .btn-cancel {
    width: 100%;
    min-width: 120px;
    height: 46px;
    font-size: 15px;
  }
  .modal-element {
    font-size: 13px;
  }
}
@media only screen and (max-width: 768px) {
  .title {
    font-size: 22px;
    line-height: 30px;
    padding: 6%;
  }
  .chassi-label {
    font-size: medium;
  }
  .image {
    margin-top: 8%;
    margin-bottom: 8%;
  }
  .modal-element {
    font-size: 12px;
  }
  .btn-next,
  .btn-pattern,
  .btn-pdf,
  .btn-cancel {
    width: 100%;
    min-width: 100px;
    height: 44px;
    font-size: 14px;
  }
  .filter-actions-row {
    gap: 10px;
  }
  .space,
  .space-first,
  .space-second,
  .space-btn {
    margin-left: 0 !important;
  }
  .radio-position {
    margin-left: 10px;
  }
}
@media only screen and (max-width: 600px) {
  .title {
    font-size: 18px;
    line-height: 24px;
    padding: 8%;
  }
  .chassi-label {
    font-size: small;
  }
  .image {
    margin-top: 10%;
    margin-bottom: 10%;
  }
  .modal-element {
    font-size: 11px;
  }
  .btn-next,
  .btn-pattern,
  .btn-pdf,
  .btn-cancel {
    width: 100%;
    min-width: 80px;
    height: 42px;
    font-size: 13px;
  }
  .filter-actions-row {
    gap: 10px;
  }
  .space,
  .space-first,
  .space-second,
  .space-btn {
    margin-left: 0 !important;
  }
  .radio-position {
    margin-left: 5px;
  }
  .modal-footer {
    flex-direction: column;
    gap: 10px;
  }
}
.modal-footer,
.action-buttons-row {
  display: flex !important;
  flex-direction: row !important;
  justify-content: flex-end !important;
  align-items: center !important;
  gap: 10px;
  width: 100%;
}
.action-button,
.action-button-return,
.btn-cancel,
.btn-pdf {
  margin-right: 0 !important;
  margin-bottom: 0 !important;
  float: none !important;
}
@media only screen and (max-width: 500px) {
  .title {
    font-size: 16px;
    line-height: 20px;
    padding: 10%;
  }
  .chassi-label {
    font-size: 13px;
  }
  .image {
    margin-top: 12%;
    margin-bottom: 12%;
  }
  .modal-element {
    font-size: 10px;
  }
  .btn-next,
  .btn-pattern,
  .btn-pdf,
  .btn-cancel {
    width: 100%;
    min-width: 60px;
  }
  .space,
  .space-first,
  .space-second,
  .space-btn {
    margin-left: 0 !important;
  }
  .radio-position {
    margin-left: 0;
  }
  .modal-footer {
    flex-direction: column;
    gap: 8px;
  }
}
@media only screen and (max-width: 500px) {
  .modal-footer,
  .action-buttons-row {
    flex-direction: row !important;
    justify-content: flex-end !important;
    gap: 8px;
  }
  .action-button,
  .action-button-return,
  .btn-cancel,
  .btn-pdf {
    width: auto;
    min-width: 60px;
  }
}
::ng-deep .p-dialog {
  border-radius: 12px;
  overflow: hidden;
}
::ng-deep .p-dialog .p-dialog-header {
  padding: 16px 20px;
  border-bottom: 1px solid #d9d9d9;
  align-items: center;
}
::ng-deep .p-dialog .p-dialog-title {
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  color: #333333;
}
::ng-deep .p-dialog .p-dialog-content {
  padding: 20px;
}
.modal-body {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 0;
}
.modal-itens {
  margin-top: 0;
  margin-bottom: 0;
}
.modal-itens-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
}
.modal-bank-info {
  margin-top: 0;
}
.modal-inform,
.modal-inform-two {
  gap: 12px;
  margin-top: 12px;
  align-items: flex-start;
  flex-wrap: wrap;
}
.modal-element-title,
.modal-element-label {
  margin: 0 0 6px 0;
  font-weight: 500;
}
.modal-element-p {
  margin: 0;
  line-height: 20px;
}
.modal-element-input,
::ng-deep .modal-element .p-inputtext,
::ng-deep .modal-element .p-dropdown,
::ng-deep .modal-element .p-multiselect {
  width: 100%;
  height: 44px;
  border-radius: 8px;
  padding-left: 12px;
}
textarea.modal-element-input {
  min-height: 96px;
  height: auto;
  padding: 10px 12px;
}
.select-top,
.space,
.space-first,
.space-second,
.space-btn {
  margin-left: 0 !important;
  margin-top: 0 !important;
}
.modal-footer {
  margin-top: 18px;
  margin-bottom: 0;
  justify-content: flex-end !important;
  gap: 10px;
  flex-wrap: wrap;
}
.action-button-return,
.action-button,
.btn-cancel,
.btn-pdf {
  width: auto;
  min-width: 104px;
  height: 38px;
  border-radius: 8px;
  margin: 0 !important;
  float: none !important;
  padding: 0 14px;
}
.action-button-return {
  border: 1px solid #046cea;
}
button.action-button-return .action-button-return-label,
.action-button .action-button-label {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}
.modal-footer .action-button,
.modal-footer .btn-cancel,
.modal-footer .btn-pdf {
  background: #046cea !important;
  border: 1px solid #046cea !important;
}
.modal-footer .action-button .action-button-label,
.modal-footer .btn-cancel .action-button-label,
.modal-footer .btn-pdf .action-button-label {
  color: #ffffff !important;
}
.modal-footer .action-button:hover:not(:disabled),
.modal-footer .btn-cancel:hover:not(:disabled),
.modal-footer .btn-pdf:hover:not(:disabled) {
  background: #0353a8 !important;
  border-color: #0353a8 !important;
}
.modal-footer .action-button:disabled,
.modal-footer .btn-cancel:disabled,
.modal-footer .btn-pdf:disabled {
  background: #e5e5e5 !important;
  border-color: #cccccc !important;
}
.modal-footer .action-button-return {
  background: #ffffff !important;
  border: 1px solid #046cea !important;
}
.modal-footer .action-button-return .action-button-return-label {
  color: #046cea !important;
}
.modal-footer .action-button-return i {
  color: #046cea !important;
}
.modal-footer .action-button-return:hover {
  background: #edf5ff !important;
  border-color: #046cea !important;
}
.modal-footer .action-button-return:hover .action-button-return-label {
  color: #046cea !important;
}
.modal-footer .action-button-return:hover i {
  color: #046cea !important;
}
.modal-footer .action-button-return:disabled,
.modal-footer .action-button-return[disabled] {
  background: #e5e5e5 !important;
  border-color: #aaaaaa !important;
  cursor: not-allowed;
  opacity: 1;
}
.modal-footer .action-button-return:disabled .action-button-return-label,
.modal-footer .action-button-return[disabled] .action-button-return-label,
.modal-footer .action-button-return:disabled i,
.modal-footer .action-button-return[disabled] i,
.modal-footer .action-button:disabled .action-button-label,
.modal-footer .action-button[disabled] .action-button-label,
.modal-footer .btn-cancel:disabled .action-button-label,
.modal-footer .btn-cancel[disabled] .action-button-label,
.modal-footer .btn-pdf:disabled .action-button-label,
.modal-footer .btn-pdf[disabled] .action-button-label,
.modal-footer .action-button:disabled i,
.modal-footer .action-button[disabled] i,
.modal-footer .btn-cancel:disabled i,
.modal-footer .btn-cancel[disabled] i,
.modal-footer .btn-pdf:disabled i,
.modal-footer .btn-pdf[disabled] i {
  color: #6f6f6f !important;
}
.modal-footer .action-button:disabled,
.modal-footer .action-button[disabled],
.modal-footer .btn-cancel:disabled,
.modal-footer .btn-cancel[disabled],
.modal-footer .btn-pdf:disabled,
.modal-footer .btn-pdf[disabled] {
  background: #e5e5e5 !important;
  border-color: #aaaaaa !important;
  opacity: 1;
}
::ng-deep .pdf-selection-dialog .p-dialog-header {
  padding: 18px 22px;
}
::ng-deep .pdf-selection-dialog .p-dialog-title {
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.01em;
  color: #2d333b;
}
::ng-deep .pdf-selection-dialog .p-dialog-content {
  padding: 14px 22px 12px 22px;
}
.modal-pdf-body {
  margin-top: 0 !important;
  gap: 10px;
}
.modal-pdf-itens {
  width: 100%;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
.modal-pdf-title {
  font-size: 19px;
  font-weight: 700;
  line-height: 28px;
  margin: 0 0 14px 0;
  color: #252b33;
}
.modal-pdf-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: stretch;
  gap: 12px;
  margin: 0;
  padding: 0;
}
.modal-pdf-option {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 52px;
  padding: 10px 12px;
  border: 1px solid #d5dde7;
  border-radius: 12px;
  background: #f8fbff;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background-color 0.2s ease;
  cursor: pointer;
}
.modal-pdf-option:hover {
  border-color: #8eb6ee;
  background: #eef5ff;
}
.modal-pdf-option:focus-within {
  border-color: #046cea;
  box-shadow: 0 0 0 2px rgba(4, 108, 234, 0.16);
  background: #eef5ff;
}
.modal-pdf-options .radio-position {
  margin-left: 0 !important;
}
.modal-pdf-options .radio-position-label {
  margin-left: 2px;
  font-size: 18px;
  font-weight: 500;
  color: #344054;
}
@media only screen and (max-width: 640px) {
  .modal-pdf-options {
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
  }
  .modal-pdf-option {
    width: 100%;
    min-height: 50px;
  }
}
.modal-pdf-actions {
  width: 100%;
  justify-content: flex-end !important;
  gap: 12px;
  margin-top: 14px;
  padding: 14px 22px 20px 22px;
  border-top: 1px solid #d9d9d9;
  flex-wrap: wrap;
}
.modal-pdf-actions .action-button-return,
.modal-pdf-actions .btn-pdf {
  min-width: 186px;
  height: 44px;
  border-radius: 8px;
  padding: 0 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  float: none;
  margin: 0;
}
.modal-pdf-actions .btn-pdf {
  width: auto;
}
.modal-pdf-action-icon {
  font-size: 15px;
  line-height: 1;
  position: static !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  margin: 0;
  top: auto !important;
  right: auto !important;
  bottom: auto !important;
  left: auto !important;
  transform: none !important;
}
.modal-pdf-actions .action-button-return .modal-pdf-action-icon {
  color: #046cea;
}
.modal-pdf-actions .btn-pdf .modal-pdf-action-icon {
  color: #ffffff;
}
.modal-pdf-actions .action-button-return .action-button-return-label,
.modal-pdf-actions .btn-pdf .action-button-label {
  display: inline-flex;
  align-items: center;
  line-height: 1.1;
  font-size: 16px;
  font-weight: 500;
}
.modal-pdf-actions .action-button-return > i,
.modal-pdf-actions .btn-pdf > i {
  position: static !important;
  transform: none !important;
  margin-right: 8px;
}
.modal-pdf-actions .action-button-return > span,
.modal-pdf-actions .btn-pdf > span {
  position: static !important;
  white-space: nowrap;
}
:host ::ng-deep .cancel-request-dialog .modal-body {
  padding: 4px 0 0;
  gap: 8px;
  margin-left: 0 !important;
  padding-left: 0 !important;
}
:host ::ng-deep .cancel-request-dialog .modal-itens,
:host ::ng-deep .cancel-request-dialog .modal-itens-title,
:host ::ng-deep .cancel-request-dialog .modal-bank-info,
:host ::ng-deep .cancel-request-dialog .modal-inform,
:host ::ng-deep .cancel-request-dialog .modal-inform-two,
:host ::ng-deep .cancel-request-dialog .modal-element {
  margin-left: 0 !important;
  padding-left: 0 !important;
  text-align: left;
}
:host ::ng-deep .cancel-request-dialog .space-first {
  margin-left: 0;
}
:host ::ng-deep .cancel-request-dialog .modal-bank-info {
  margin-top: 0;
  margin-bottom: 16px;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 14px;
}
:host ::ng-deep .cancel-request-dialog .modal-itens {
  margin-top: 0;
  margin-bottom: 0;
  margin-left: 0 !important;
  padding-left: 0 !important;
}
:host ::ng-deep .cancel-request-dialog .modal-itens-title {
  margin-top: 0;
  margin-bottom: 14px;
  margin-left: 0 !important;
  font-weight: 700;
  letter-spacing: -0.01em;
}
:host ::ng-deep .cancel-request-dialog .modal-bank-info,
:host ::ng-deep .cancel-request-dialog .space {
  margin-left: 0 !important;
  padding-left: 0 !important;
}
:host ::ng-deep .cancel-request-dialog .modal-element {
  margin: 0;
  padding-left: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
:host ::ng-deep .cancel-request-dialog .modal-element-p {
  margin: 0;
}
:host ::ng-deep .cancel-request-dialog .modal-element-label,
:host ::ng-deep .cancel-request-dialog .modal-element-title {
  display: block;
  margin-bottom: 0;
  font-weight: 600;
  color: #2d333b;
}
:host ::ng-deep .cancel-request-dialog .modal-inform {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  align-items: start;
}
:host ::ng-deep .cancel-request-dialog .modal-inform-two {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 14px;
  margin-top: 14px;
}
:host ::ng-deep .cancel-request-dialog .modal-inform input,
:host ::ng-deep .cancel-request-dialog .modal-inform-two input,
:host ::ng-deep .cancel-request-dialog .modal-inform-two textarea,
:host ::ng-deep .cancel-request-dialog .modal-inform-two p-dropdown,
:host ::ng-deep .cancel-request-dialog .modal-inform-two p-calendar {
  width: 100%;
}
:host ::ng-deep .cancel-request-dialog #observationsSearch.modal-element-input {
  height: 78px;
  min-height: 78px;
  padding: 8px 12px;
  resize: vertical;
}
:host ::ng-deep .cancel-request-dialog .field-limit-hint {
  display: block;
  margin-top: 2px;
  font-size: 12px;
  line-height: 16px;
  color: #6f7780;
  font-variant-numeric: tabular-nums;
  text-align: left;
}
:host ::ng-deep .cancel-request-dialog .cancel-modal-actions {
  border-top: 1px solid #e3e7eb;
  padding-top: 16px;
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}
:host ::ng-deep .cancel-request-dialog .cancel-modal-actions .action-button-return,
:host ::ng-deep .cancel-request-dialog .cancel-modal-actions .btn-cancel {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
:host ::ng-deep .cancel-request-dialog .cancel-modal-actions .cancel-return-icon {
  font-size: 13px;
  color: #046cea;
}
:host ::ng-deep .cancel-request-dialog .cancel-submit-button {
  min-width: 235px;
}
:host ::ng-deep .modal-footer .undo-submit-button {
  min-width: 215px;
}
:host ::ng-deep .cancel-request-dialog .cancel-submit-icon {
  font-size: 13px;
  margin-right: 6px;
  color: #ffffff;
}
:host ::ng-deep .undo-cancel-dialog .modal-body {
  padding: 4px 0 0;
  gap: 8px;
}
:host ::ng-deep .undo-cancel-dialog .modal-itens {
  margin-top: 0;
  margin-bottom: 0;
}
:host ::ng-deep .undo-cancel-dialog .modal-bank-info {
  margin-top: 0;
  margin-bottom: 16px;
}
:host ::ng-deep .undo-cancel-dialog .modal-element-p {
  margin: 0;
  line-height: 1.35;
}
:host ::ng-deep .undo-cancel-dialog .undo-modal-actions {
  border-top: 1px solid #e3e7eb;
  padding-top: 16px;
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
:host ::ng-deep .undo-cancel-dialog .undo-modal-actions .action-button-return,
:host ::ng-deep .undo-cancel-dialog .undo-modal-actions .btn-cancel {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
:host ::ng-deep .undo-cancel-dialog .undo-return-icon {
  font-size: 13px;
  margin-right: 6px;
  color: #046cea;
}
:host ::ng-deep .undo-cancel-dialog .undo-submit-icon {
  font-size: 13px;
  margin-right: 6px;
  color: #ffffff;
}
@media (max-width: 768px) {
  :host ::ng-deep .cancel-request-dialog .modal-inform {
    grid-template-columns: minmax(0, 1fr);
  }
  :host ::ng-deep .cancel-request-dialog .cancel-submit-button,
  :host ::ng-deep .modal-footer .undo-submit-button {
    min-width: 100%;
  }
}
::ng-deep .cancel-request-dialog .modal-body,
::ng-deep .cancel-request-dialog .modal-itens,
::ng-deep .cancel-request-dialog .modal-itens-title,
::ng-deep .cancel-request-dialog .modal-bank-info,
::ng-deep .cancel-request-dialog .modal-inform,
::ng-deep .cancel-request-dialog .modal-inform-two,
::ng-deep .cancel-request-dialog .modal-element {
  margin-left: 0 !important;
  padding-left: 0 !important;
  text-align: left !important;
}
::ng-deep .cancel-request-dialog .modal-itens,
::ng-deep .cancel-request-dialog .modal-bank-info,
::ng-deep .cancel-request-dialog .modal-inform,
::ng-deep .cancel-request-dialog .modal-inform-two {
  width: 100%;
}
/*# sourceMappingURL=contract-search-dealer.component-SQJK4ZG4.css.map */
